<template>
  <div class="content">
    <h1>Privacy Policy</h1>

    <p>
      This Privacy Policy describes how our application 
      collects, uses, and protects your information when you use our mobile application.
    </p>

    <h2>1. Information We Collect</h2>
    <p>
      We do not collect personally identifiable information unless explicitly provided by the user.
    </p>

    <h2>2. Camera Permission Usage</h2>
    <p>
      Our application requests access to your device camera for the following purpose:
    </p>
    <ul>
      <li>To capture images or scan data within the app</li>
    </ul>
    <p>
      We do NOT store, share, or upload any images or videos captured using the camera
      unless explicitly stated and initiated by the user.
    </p>

    <h2>3. Data Usage</h2>
    <p>
      Any data accessed within the app is used solely to provide and improve app functionality.
      We do not sell or share your data with third parties.
    </p>

    <h2>4. Third-Party Services</h2>
    <p>
      Our app may use third-party services (such as analytics or hosting providers),
      which may collect information used to identify you.
    </p>

    <h2>5. Data Security</h2>
    <p>
      We value your trust in providing your information, thus we strive to use commercially
      acceptable means of protecting it.
    </p>

    <h2>6. User Consent</h2>
    <p>
      By using our app, you consent to our Privacy Policy.
    </p>

    <h2>7. Changes to This Policy</h2>
    <p>
      We may update our Privacy Policy from time to time. Any changes will be posted on this page.
    </p>

    <h2>8. Contact Us</h2>
    <p>
      If you have any questions or suggestions about our Privacy Policy,
      please contact us at:
    </p>
    <p><strong>Email:</strong> royalmarketingroup@gmail.com</p>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
};
</script>

<style scoped>
.content {
  padding: 20px;
  max-width: 800px;
  margin: auto;
  line-height: 1.6;
}

h1 {
  margin-bottom: 20px;
}

h2 {
  margin-top: 20px;
}
</style>